export default __webpack_public_path__ + "static/media/pair.7760f5bd.svg";